import { z } from 'zod'

/** Every button a place page can show, in the order the automatic row picks them. */
export const LISTING_BUTTON_KINDS = [
  'lunch_menu',
  'menu',
  'phone',
  'directions',
  'website',
  'instagram',
  'share',
] as const

export const listingButtonKindSchema = z.enum(LISTING_BUTTON_KINDS)
export type ListingButtonKind = z.infer<typeof listingButtonKindSchema>

export const MAX_LISTING_BUTTONS = 4

export const chosenListingButtonsSchema = z
  .array(listingButtonKindSchema)
  .min(1)
  .max(MAX_LISTING_BUTTONS)
  .refine((kinds) => new Set(kinds).size === kinds.length, { message: 'Each button only once' })

export const listingButtonAvailabilitySchema = z.object({
  lunch_menu: z.boolean(),
  menu: z.boolean(),
  phone: z.boolean(),
  directions: z.boolean(),
  website: z.boolean(),
  instagram: z.boolean(),
  share: z.boolean(),
})
export type ListingButtonAvailability = z.infer<typeof listingButtonAvailabilitySchema>

export const listingButtonsStateSchema = z.object({
  /** The owner's choice in order; null means automatic. */
  chosen: z.array(listingButtonKindSchema).nullable(),
  available: listingButtonAvailabilitySchema,
  /** What the place page shows right now. */
  resolved: z.array(listingButtonKindSchema),
})
export type ListingButtonsState = z.infer<typeof listingButtonsStateSchema>

export const updateListingButtonsRequestSchema = z.object({
  chosen: chosenListingButtonsSchema.nullable(),
})
export type UpdateListingButtonsRequest = z.infer<typeof updateListingButtonsRequestSchema>
